module.exports = __webpack_public_path__ + "style/img/PD_icon_BossBI 1.46006f16.png";